"use client"

import { useState } from "react"
import { Menu, LogOut } from "lucide-react"
import { Sidebar } from "../components/sidebar"
import { RightSidebar } from "../components/right-sidebar"
import { Home } from "./HomeScreenPage/Home"
import { Profile } from "./ProfilePage/profile"
import { Settings } from "./SettingPage/settings"
import { Notifications } from "./NotificationsPage/notifications"
import { Meetings } from "./MeetingPage/meetings"
import "./HomeScreenPage/Home.css"

export default function HomeScreenManager(
  {
    userId,
    getLinkAfterCreateRoom,
    adminLink,
    sellerLink
  }
) {
  const [state, setState] = useState({
    currentPage: "home",
    isSidebarOpen: true,
    isRightSidebarOpen: true
  })

  const navigateToPage = (page) => {
    setState((prev) => ({ ...prev, currentPage: page }))
  }

  const toggleSidebar = () => {
    setState((prev) => ({ ...prev, isSidebarOpen: !prev.isSidebarOpen }))
  }

  const toggleRightSidebar = () => {
    setState((prev) => ({ ...prev, isRightSidebarOpen: !prev.isRightSidebarOpen }))
  }

  const handleLogout = () => {
    console.log("User logged out")
    // Add your logout logic here
  }

  const getPageTitle = () => {
    switch (state.currentPage) {
      case "home":
        return "Home"
      case "profile":
        return "Profile"
      case "settings":
        return "Settings"
      case "notifications":
        return "Notifications"
      case "meetings":
        return "Meetings"
      default:
        return "Home"
    }
  }

  const renderCurrentPage = () => {
    switch (state.currentPage) {
      case "home":
        return <Home userId={userId} adminLink={adminLink} sellerLink={sellerLink} getLinkAfterCreateRoom={getLinkAfterCreateRoom} />
      case "profile":
        return <Profile userId={userId} adminLink={adminLink} sellerLink={sellerLink} />
      case "settings":
        return <Settings userId={userId} adminLink={adminLink} sellerLink={sellerLink} />
      case "notifications":
        return <Notifications userId={userId} adminLink={adminLink} sellerLink={sellerLink} />
      case "meetings":
        return <Meetings userId={userId} adminLink={adminLink} sellerLink={sellerLink} />
      default:
        return <Home userId={userId} adminLink={adminLink} sellerLink={sellerLink} getLinkAfterCreateRoom={getLinkAfterCreateRoom} />
    }
  }

  // Check if right sidebar should be shown
  const shouldShowRightSidebar = state.currentPage !== "settings"

  return (
    <div className="app-container">
      {/* Overlay for mobile only */}
      <div
        className={`overlay ${(state.isSidebarOpen || (state.isRightSidebarOpen && shouldShowRightSidebar)) && window.innerWidth <= 768 ? "active" : ""}`}
        onClick={() => {
          if (window.innerWidth <= 768) {
            setState((prev) => ({ ...prev, isSidebarOpen: false, isRightSidebarOpen: false }))
          }
        }}
      />

      {/* Left Sidebar */}
      <Sidebar
        isOpen={state.isSidebarOpen}
        currentPage={state.currentPage}
        onNavigate={navigateToPage}
        onClose={() => setState((prev) => ({ ...prev, isSidebarOpen: false }))}
      />

      {/* Main Container */}
      <div className={`main-container ${!state.isSidebarOpen ? "expanded" : ""}`}>
        {/* Top Navbar */}
        <nav className="top-navbar">
          <div className="navbar-left">
            <button className="sidebar-toggle" onClick={toggleSidebar}>
              <Menu />
            </button>
            <h1 className="page-title">{getPageTitle()}</h1>
          </div>
          <button className="logout-button" onClick={handleLogout}>
            <LogOut />
            Logout
          </button>
        </nav>

        {/* Content Area */}
        <div className="content-area" style={{ marginRight: (state.isRightSidebarOpen && shouldShowRightSidebar) ? "320px" : "0" }}>
          <main className="main-content">{renderCurrentPage()}</main>
        </div>
      </div>

      {/* Right Sidebar - Only show when not on settings page */}
      {shouldShowRightSidebar && (
        <RightSidebar
          isOpen={state.isRightSidebarOpen}
          onClose={() => setState((prev) => ({ ...prev, isRightSidebarOpen: false }))}
        />
      )}
    </div>
  )
}